/**
 * Ryder Logo Component
 * Uses official Ryder white SVG logo from ryder.id
 * Supports "light" (white logo for dark bg) and "dark" (black logo for light bg) variants
 */

interface RyderLogoProps {
  className?: string;
  /** "dark" renders the logo in black (for light backgrounds), "light" renders white (for dark backgrounds) */
  variant?: "dark" | "light";
}

export default function RyderLogo({ className = "h-7 w-auto", variant = "dark" }: RyderLogoProps) {
  return (
    <img 
      src="https://files.manuscdn.com/user_upload_by_module/session_file/310519663243023818/tFbvNREvblJviuWq.svg"
      alt="Ryder"
      className={className}
      style={{ 
        filter: variant === "dark" ? "brightness(0)" : "none"
      }}
    />
  );
}
